import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initials',
    standalone: true
})
export class InitialsPipe implements PipeTransform {
    transform(details: any): string {
        if (typeof details === "object" && !Array.isArray(details) && details["first_name"] && details["last_name"]) {
            return (details.first_name.charAt(0) + details.last_name.charAt(0)).toUpperCase();
        }

        return details;
    }
}